import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

const initialState = {
  viewAlluser: [],
  userCount: 0,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const getAllUsers = createAsyncThunk(
  'user/viewAll',
  async (page, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      //const response = await axios.get('/api/userRoles',{}, { headers: {"Authorization" : `Bearer ${tokenStr}`} });

      //   let response = await axios({
      //     url: '/api/user/list/detailed?from=1&to=100',
      //     method: 'get',
      //     //timeout: 8000,
      //     headers: {
      //         //'Content-Type': 'application/json',
      //         "Authorization" : `Bearer ${tokenStr}`
      //     }
      // })

      let response = await axios({
        url: '/api/user/list/detailed?page=' + page,
        method: 'get',
        //timeout: 8000,
        headers: {
          //'Content-Type': 'application/json',
          "Authorization": `Bearer ${tokenStr}`
        }
      })

      let data = response.data;
      // console.log(data)
      if (response.status === 200) {
        return data;
      }
      else if (data.code === 200) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);


export const userStatusChange = createAsyncThunk(
  'user/activatestatus',
  async (udata, thunkAPI) => {
    try {
      const { auth } = thunkAPI.getState()
      let tokenStr = auth.user.token;
      const response = await axios.patch('/api/user/activeStatus', udata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

      let data = response.data;
      //  console.log(data)
      if (response.status === 200) {
        return data;
      }
      if (response.status === 201) {
        return data;
      }
      else {
        return thunkAPI.rejectWithValue(data);
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }

      return thunkAPI.rejectWithValue(err.response.data)
    }
  }
);



export const manageAlluserSlice = createSlice({
  name: 'userviewAll',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    clearStateAlluser: (state, { payload }) => {
      //state.user = {};
      // state.isFetching = false;
      // state.isSuccess = false;
      state.isError = false;
      state.errorMessage = '';
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: {
    [getAllUsers.fulfilled]: (state, { payload }) => {

      state.viewAlluser = payload.data.filteredUsers;
      state.userCount = payload.data.countObj.count;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getAllUsers.pending]: (state) => {
      state.isFetching = true;
    },
    [getAllUsers.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      if (payload) {
        state.errorMessage = payload.message;
      }
      else {
        state.errorMessage = 'Internal error';
      }
    }
  },
});

export const { clearStateAlluser } = manageAlluserSlice.actions;

export function clearState() {

  return async (dispatch) => {
    dispatch(clearStateAlluser());
  }
}

export const fetchUserData = (page) => async (dispatch, getState) => {
  const { auth } = getState()
  let token = auth.user.token;
  return axios
    .get('/api/user/list/detailed?page=' + page, {}, {
      headers: {
        'Authorization': 'Bearer ' + token,
      }
    })
    .then((response) => {
      let res = response.data;
      return res;
    });
};

export const manageAlluserSelector = (state) => state.manageusers;

export default manageAlluserSlice.reducer;
